import React from 'react'
import { Slider, withStyles } from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import { liabilityLimitPretty } from '../../../services/utils'
import './SkywatchSlider.scss'

export const LiabilityLimitSlider = ({ offers, startValue, onLiabilityChange }) => {
  const [sliderValue, setSliderValue] = React.useState(startValue)

  const valuetext = value => value / 1000000 + 'M'

  const handleChange = value => {
    setSliderValue(value)
    onLiabilityChange({ target: { value: value } })
  }

  const getMarks = limits => {
    let marks = []
    limits.forEach(limit => {
      let index = offers.findIndex(x => x.liabilityLimit == limit)
      if (index > 0) {
        marks.push({
          label: liabilityLimitPretty(offers[index].liabilityLimit),
          value: limit,
        })
      }
    })
    return marks
  }

  return (
    <>
      <FlexView>
        <div className="text-body black margin-top-basic">Liability Limit: {liabilityLimitPretty(sliderValue)}</div>
        <div className="text-body black margin-left-6"></div>
      </FlexView>
      {offers.length > 0 && (
        <SkywatchSlider
          step={500000}
          defaultValue={startValue}
          textFormatFunction={valuetext}
          onValueChange={handleChange}
          min={offers[0].liabilityLimit}
          marks={getMarks([1000000, 5000000, 10000000, 25000000, 50000000])}
          max={offers[offers.length - 1].liabilityLimit}
        />
      )}
    </>
  )
}

export const SkywatchSlider = ({ min, max, onValueChange, marks = [], textFormatFunction, step, defaultValue, highlighted = false }) => {
  // TODO: figure out how to switch to Control and lose the error in the console after changing a value
  const handleChange = (event, value) => onValueChange(value)

  return (
    <FlexView column vAlignContent={'center'}>
      <PrettoSlider
        id={highlighted ? 'slider-highlighted' : ''}
        defaultValue={defaultValue}
        marks={marks}
        valueLabelFormat={textFormatFunction}
        step={step}
        min={min}
        max={max}
        onChangeCommitted={handleChange}
        color={'primary'}
        valueLabelDisplay={'auto'}
      />
    </FlexView>
  )
}

const PrettoSlider = withStyles({
  root: {
    height: 10,
  },
  mark: {
    height: 6,
    width: 6,
    borderRadius: 6,
    marginTop: 2,
    marginLeft: -7,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 10,
    borderRadius: 6,
  },
  rail: {
    height: 10,
    borderRadius: 6,
  },
})(Slider)
